import { useTranslation } from "react-i18next";

import type { CategoryRoom } from "../../../../../api/categoryRooms/categoryRoomsApiSlice";
import { getEquipmentName } from "../../../../../util";

/**
 * The room the time step is for, in place of the city/district choice, when
 * the customer came in object-first (#3035). Changing the room is the header's
 * back button, which leads to the room list.
 */
const PickedRoomSummary = ({ room }: { room: CategoryRoom }) => {
  const { t } = useTranslation();
  const place = [room.city, room.district].filter(Boolean).join(", ");
  return (
    <div className="flex items-center gap-4 rounded-[12px] border border-primary bg-white p-3">
      {room.featuredImage && (
        <img className="h-14 w-14 rounded-lg object-cover" src={room.featuredImage} alt="" />
      )}
      <div className="flex flex-col">
        <span className="text-xs text-foreground/60">{t("book_location.object_first.picked_room")}</span>
        <span className="text-base font-medium text-foreground">
          {getEquipmentName(room.name, room.langNames ?? undefined, "title")}
        </span>
        {place && <span className="text-sm text-foreground/70">{place}</span>}
      </div>
    </div>
  );
};

export default PickedRoomSummary;
